import { render, staticRenderFns } from "./SurveyVotes.vue?vue&type=template&id=2cce5e4c&"
import script from "./SurveyVotes.vue?vue&type=script&lang=js&"
export * from "./SurveyVotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports